import React, { ReactElement } from "react";
import { QualityHubTasksListHeaderProps } from './QualityHubTasksListHeader.types';
import { LargeBody } from "src/components/Text";
import { Link } from "react-router-dom";
import Visage2Icon from "src/visage2/Visage2Icon/Visage2Icon";
import { useSelector } from "react-redux";

/**
 * Renders the header for the QualityHubTasksList component.
 *
 * @param {QualityHubTasksListHeaderProps} props - The component props
 * @returns {ReactElement | null} The rendered component
 */
function QualityHubTasksListHeader({
    smallViewMode = false,
    title,
}: QualityHubTasksListHeaderProps): ReactElement | null {
    const colorMode = useSelector<Spintr.AppState, Spintr.AppState["ui"]["colorMode"]>(
        (appState) => appState.ui.colorMode,
    );

    const titleColor = colorMode === "contrast-light"
        ? "black"
        : "contentDark";

    const inner = (
        <LargeBody color={titleColor}>
            {title}
        </LargeBody>
    );

    const elementToRender = smallViewMode ? (
        <Link to="/quality-hub" className="QualityHubTasksListHeader-link">
            <Visage2Icon icon="arrow-left-2" />
            {inner}
        </Link>
    ) : inner;

    return (
        <div className="QualityHubTasksListHeader lightPrimaryBGColor">
            {elementToRender}
        </div>
    );
}

export default QualityHubTasksListHeader;

